export const ROOT_ELEMENT = document.getElementById("root");
export const MODAL_ROOT_ELEMENT = document.getElementById("modal-root");
